import script from "./RentalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RentalCard.vue?vue&type=script&setup=true&lang=js"

import "./RentalCard.vue?vue&type=style&index=0&id=492939e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492939e6"]])

export default __exports__